module.exports = __webpack_public_path__ + "public/img/lotteryGift.e9b4f66b.png";